module.exports = __webpack_public_path__ + "assets/sort.e5b5e9a0.svg";